/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Safecharge
 */
export class Safecharge {
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    hashAlgo: string;
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    merchantId: string;
    /**
     *
     * @type {string}
     * @memberof Safecharge
     */
    merchantSiteId: string;
    /**
     *
     * @type {boolean}
     * @memberof Safecharge
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Safecharge
     */
    autoApprove: boolean;
}
